<template>
  <nav aria-label="breadcrumb" v-if="breadcrumbs.length">
    <ul class="breadcrumb">
      <li v-for="(crumb, index) in breadcrumbs" :key="index">
        <!-- Link for all except last -->
        <router-link
          v-if="crumb.to && index !== breadcrumbs.length - 1"
          :to="crumb.to"
          class="flex items-center text-gray-400 hover:text-gray-600 no-underline"
        >
          <component
            v-if="crumb.icon"
            :is="iconsMap[crumb.icon]"
            class="size-6 shrink-0 mr-2"
            aria-hidden="true"
          />
          <span>{{ crumb.label }} /</span>
        </router-link>

        <!-- Last item or no link -->
        <span v-else class="flex items-center text-gray-600">
          <component
            v-if="crumb.icon"
            :is="iconsMap[crumb.icon]"
            class="size-6 shrink-0 mr-2"
            aria-hidden="true"
          />
          {{ crumb.label }}
        </span>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { UsersIcon, BuildingOffice2Icon, DocumentTextIcon } from "@heroicons/vue/24/outline"; // example icons

const iconsMap = {
  UsersIcon: UsersIcon,
  BuildingOffice2Icon: BuildingOffice2Icon,
  DocumentTextIcon: DocumentTextIcon
};

const route = useRoute();

const breadcrumbs = computed(() => {
  const bc = route.meta.breadcrumb;
  if (typeof bc === "function") return bc(route);
  if (Array.isArray(bc)) return bc;
  return [];
});

</script>

<style scoped>
.breadcrumb {
  list-style: none;
  display: flex;
  gap: 5px;
}
.breadcrumb li {
  display: inline;
}
.breadcrumb li a {
  text-decoration: none;
}
.breadcrumb li a span {
  font-weight: 500;
}
</style>
